import * as fromDatatype from "../datatype-library";

export interface bl_alg_cc_automation_rule_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface; 
    namespace : fromDatatype.VarcharDatatypeClass
    module_guid : fromDatatype.GuidDataFieldInterface ;
    applet_guid : fromDatatype.VarcharDatatypeInterface ;
    code: fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface
    description : fromDatatype.VarcharDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface
    acl_config : fromDatatype.JsonDatatypeInterface
    acl_policy : fromDatatype.JsonDatatypeInterface
    created_date : fromDatatype.TimestampTzDatatypeInterface ;
    updated_date : fromDatatype.TimestampTzDatatypeInterface ;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
}

export class bl_alg_cc_automation_rule_hdr_RowClass
  implements bl_alg_cc_automation_rule_hdr_RowInterface {
    guid : fromDatatype.GuidDataFieldInterface; 
    namespace : fromDatatype.VarcharDatatypeClass
    module_guid : fromDatatype.GuidDataFieldInterface ;
    applet_guid : fromDatatype.VarcharDatatypeInterface ;
    code: fromDatatype.VarcharDatatypeInterface;
    name : fromDatatype.VarcharDatatypeInterface
    description : fromDatatype.VarcharDatatypeInterface;
    property_json : fromDatatype.JsonDatatypeInterface
    acl_config : fromDatatype.JsonDatatypeInterface
    acl_policy : fromDatatype.JsonDatatypeInterface
    created_date : fromDatatype.TimestampTzDatatypeInterface ;
    updated_date : fromDatatype.TimestampTzDatatypeInterface ;
    created_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    updated_by_subject_guid : fromDatatype.GuidDataFieldInterface ;
    status : fromDatatype.StatusDataFieldInterface
    revision : fromDatatype.GuidDataFieldInterface;
    vrsn : fromDatatype.VarcharDatatypeInterface;
  }